/* Auto-generated by scripts/emit-build-info.js */
export const BUILD_INFO = {
  "version": "1.19.0",
  "buildTime": "2026-11-03T09:41:53.892Z",
  "gitSha": "0cd211e"
} as const;
export type BuildInfo = typeof BUILD_INFO;
